import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PatternCategory } from './models/patterns.interfaces';
import { patternMap } from './patterns-map';

export const validateField = (
  category: PatternCategory,
  fieldName: string,
  value: string
): boolean => {
  const patterns = patternMap[category];
  const pattern = patterns[fieldName];

  if (!pattern) {
    throw new Error(
      `Pattern for field ${fieldName} not found in category ${category}.`
    );
  }

  return pattern.test(value);
};

export const patternValidator = (
  category: PatternCategory,
  fieldName: string
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = validateField(category, fieldName, control.value);
    return isValid ? null : { pattern: { value: control.value } };
  };
};

export function extractMaxLength(pattern: RegExp): string | null {
  const regexStr = pattern.source;

  // Look for quantifiers like {0,55}, {1,56}, etc.
  const quantifierMatch = regexStr.match(/\{(\d+),(\d+)\}/);
  if (quantifierMatch) {
    const [, min, max] = quantifierMatch;
    // Add 1 for the required first character (e.g., [a-zA-Z])
    return String(+max + 1);
  }

  return null;
}
